/**
 * save-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { validateFor, validateOpaqueID } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * When a user saves a subject context, then the server sends an unsolicited
 * {@link SaveResponse} to each other client.
 */
@validateFor(MessageTag.RSP_SAVE)
export class SaveResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SAVE;

  @validateOpaqueID()
  public userId : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/save-response.ts